/* ══════════════════════════════════════════════════════════
   YOURAYOU — Reviews JS
   Pagination, filter, write modal, star rating, submit,
   photo upload, review photo lightbox
   Load with <script src="..." defer></script>
   ══════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  function init() {

    /* ── i18n from data attributes ── */
    var sec = document.querySelector('[data-i18n-anonymous]');
    var i18n = {
      anonymous: sec ? sec.getAttribute('data-i18n-anonymous') : 'Anonymous',
      review:    sec ? sec.getAttribute('data-i18n-review')    : 'Review',
      verified:  sec ? sec.getAttribute('data-i18n-verified')  : 'Verified purchase',
      justNow:   sec ? sec.getAttribute('data-i18n-just-now')  : 'just now'
    };

    /* ── Review pagination ── */
    var PER_PAGE = 3;
    var currentPage = 1;
    var paginationEl = document.querySelector('.ya-rev-pagination');
    var filteredReviews = Array.from(document.querySelectorAll('.ya-rev-item'));
    var totalPages = Math.ceil(filteredReviews.length / PER_PAGE);
    var isInitialLoad = true;

    function showPage(page) {
      currentPage = page;
      var allDomReviews = Array.from(document.querySelectorAll('.ya-rev-item'));
      allDomReviews.forEach(function(r) { r.classList.add('hidden'); });
      var start = (page - 1) * PER_PAGE;
      filteredReviews.forEach(function(r, i) {
        r.classList.toggle('hidden', i < start || i >= start + PER_PAGE);
      });
      renderPagination();
      if (!isInitialLoad) {
        var reviewsSection = document.querySelector('.ya-rev-section');
        if (reviewsSection) reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      isInitialLoad = false;
    }

    function renderPagination() {
      if (!paginationEl) return;
      if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }
      paginationEl.innerHTML = '';
      var prev = document.createElement('button');
      prev.className = 'ya-rev-page-btn arrow';
      prev.textContent = '\u2190';
      prev.disabled = currentPage === 1;
      prev.style.opacity = currentPage === 1 ? '0.3' : '';
      prev.addEventListener('click', function() { if (currentPage > 1) showPage(currentPage - 1); });
      paginationEl.appendChild(prev);
      for (var i = 1; i <= totalPages; i++) {
        (function(p) {
          var btn = document.createElement('button');
          btn.className = 'ya-rev-page-btn' + (p === currentPage ? ' active' : '');
          btn.textContent = p;
          btn.addEventListener('click', function() { showPage(p); });
          paginationEl.appendChild(btn);
        })(i);
      }
      var next = document.createElement('button');
      next.className = 'ya-rev-page-btn arrow';
      next.textContent = '\u2192';
      next.disabled = currentPage === totalPages;
      next.style.opacity = currentPage === totalPages ? '0.3' : '';
      next.addEventListener('click', function() { if (currentPage < totalPages) showPage(currentPage + 1); });
      paginationEl.appendChild(next);
    }

    if (filteredReviews.length > 0) showPage(1);

    /* ── Filter dropdown ── */
    var filterBtn = document.querySelector('.ya-rev-filter-btn');
    var filterDropdown = document.querySelector('.ya-rev-filter');
    var activeStarFilter = null;

    if (filterBtn) {
      filterBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (filterDropdown) filterDropdown.classList.toggle('open');
      });
    }

    document.addEventListener('click', function(e) {
      if (filterDropdown && !filterDropdown.contains(e.target) && e.target !== filterBtn) {
        filterDropdown.classList.remove('open');
      }
    });

    function getStarCount(reviewEl) {
      var starsEl = reviewEl.querySelector('.ya-rev-stars');
      if (!starsEl) return 5;
      return (starsEl.textContent.match(/\u2605/g) || []).length;
    }

    function applyFilter(stars) {
      activeStarFilter = stars;
      var allDomReviews = Array.from(document.querySelectorAll('.ya-rev-item'));
      filteredReviews = stars === null ? allDomReviews : allDomReviews.filter(function(r) { return getStarCount(r) === stars; });
      totalPages = Math.ceil(filteredReviews.length / PER_PAGE);
      showPage(1);
      if (filterBtn) filterBtn.classList.toggle('active', stars !== null);
      document.querySelectorAll('.ya-rev-filter__option').forEach(function(opt) {
        opt.classList.toggle('selected', parseInt(opt.dataset.stars) === stars);
      });
      if (filterDropdown) filterDropdown.classList.remove('open');
    }

    document.querySelectorAll('.ya-rev-filter__option').forEach(function(opt) {
      opt.addEventListener('click', function() {
        applyFilter(parseInt(opt.dataset.stars));
      });
    });

    var filterClear = document.querySelector('.ya-rev-filter__clear');
    if (filterClear) filterClear.addEventListener('click', function() { applyFilter(null); });

    /* ── Review write modal ── */
    function openRW() {
      var modal = document.querySelector('.ya-rw-modal');
      var overlay = document.querySelector('.ya-rw-overlay');
      if (modal) modal.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeRW() {
      var modal = document.querySelector('.ya-rw-modal');
      var overlay = document.querySelector('.ya-rw-overlay');
      if (modal) modal.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    var rwWriteBtn = document.querySelector('.ya-rev-write-btn');
    if (rwWriteBtn) rwWriteBtn.addEventListener('click', openRW);

    var rwCloseBtn = document.querySelector('.ya-rw-close');
    if (rwCloseBtn) rwCloseBtn.addEventListener('click', closeRW);

    var rwOverlay = document.querySelector('.ya-rw-overlay');
    if (rwOverlay) rwOverlay.addEventListener('click', closeRW);

    /* ── Star rating in modal ── */
    var rwStar = 0;
    document.querySelectorAll('.ya-rw-star').forEach(function(btn) {
      btn.addEventListener('click', function() {
        rwStar = parseInt(btn.dataset.s);
        document.querySelectorAll('.ya-rw-star').forEach(function(b) {
          b.classList.toggle('on', parseInt(b.dataset.s) <= rwStar);
        });
      });
    });

    /* ── Review submit ── */
    var rwSubmitBtn = document.querySelector('.ya-rw-submit');
    if (rwSubmitBtn) {
      rwSubmitBtn.addEventListener('click', function() {
        var inputs = document.querySelectorAll('.ya-rw-input');
        var name = inputs[0] ? inputs[0].value.trim() : '';
        name = name || i18n.anonymous;
        var title = inputs[1] ? inputs[1].value.trim() : '';
        title = title || i18n.review;
        var bodyEl = document.querySelector('.ya-rw-textarea');
        var body = bodyEl ? bodyEl.value.trim() : '';
        var photoInput = document.querySelector('.ya-rw-photo-input');
        var photos = photoInput ? Array.from(photoInput.files) : [];
        var stars = rwStar || 5;

        var starStr = '';
        for (var s = 0; s < 5; s++) starStr += s < stars ? '\u2605' : '\u2606';
        var photosHTML = '';
        photos.forEach(function(f) { photosHTML += '<img class="ya-rev-photo" src="' + URL.createObjectURL(f) + '" alt="">'; });

        var item = document.createElement('div');
        item.className = 'ya-rev-item';
        item.innerHTML =
          '<div class="ya-rev-meta"><div class="ya-rev-name">' + name + '</div><div class="ya-rev-verified"><span class="ya-rev-vdot"></span>' + i18n.verified + '</div></div>' +
          '<div class="ya-rev-content"><div class="ya-rev-stars">' + starStr + '</div><div class="ya-rev-date">' + i18n.justNow + '</div><div class="ya-rev-title">' + title + '</div>' +
          (body ? '<div class="ya-rev-body">' + body + '</div>' : '') +
          '</div><div class="ya-rev-photos">' + photosHTML + '</div>';

        var reviewList = document.querySelector('.ya-rev-list');
        if (reviewList) reviewList.prepend(item);
        filteredReviews = Array.from(document.querySelectorAll('.ya-rev-item'));
        totalPages = Math.ceil(filteredReviews.length / PER_PAGE);
        showPage(1);
        if (inputs[0]) inputs[0].value = '';
        if (inputs[1]) inputs[1].value = '';
        if (bodyEl) bodyEl.value = '';
        var previewEl = document.querySelector('.ya-rw-photo-preview');
        if (previewEl) previewEl.innerHTML = '';
        if (photoInput) photoInput.value = '';
        closeRW();
      });
    }

    /* ── Photo upload preview ── */
    var rwPhotoInput = document.querySelector('.ya-rw-photo-input');
    if (rwPhotoInput) {
      rwPhotoInput.addEventListener('change', function() {
        var preview = document.querySelector('.ya-rw-photo-preview');
        if (!preview) return;
        preview.innerHTML = '';
        Array.from(this.files).forEach(function(file) {
          var img = document.createElement('img');
          img.className = 'ya-rw-photo-thumb';
          img.src = URL.createObjectURL(file);
          preview.appendChild(img);
        });
      });
    }

    /* ── Review photo lightbox ── */
    var revLB = document.querySelector('.ya-revlb');
    var revLBImg = document.querySelector('.ya-revlb__img');
    var revLBClose = document.querySelector('.ya-revlb__close');

    if (revLBClose) {
      revLBClose.addEventListener('click', function() {
        if (revLB) revLB.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
    if (revLB) {
      revLB.addEventListener('click', function(e) {
        if (e.target === revLB) { revLB.classList.remove('open'); document.body.style.overflow = ''; }
      });
    }
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('ya-rev-photo')) {
        if (revLBImg) revLBImg.src = e.target.src;
        if (revLB) revLB.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    });
    document.addEventListener('keydown', function(e) {
      if (revLB && revLB.classList.contains('open') && e.key === 'Escape') {
        revLB.classList.remove('open');
        document.body.style.overflow = '';
      }
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
